import { Component, Input } from '@angular/core';
import { DateService } from 'src/app/common/date.service';
import { FiltersComponent } from 'src/app/common/filters.component';
import { OfferTransportKind } from '@/common/enums/OfferTransportKind';

@Component({
	selector: 'app-terms-filters',
	templateUrl: './terms-filters.component.html',
	styleUrls: ['./terms-filters.component.css'],
})
export class TermsFiltersComponent extends FiltersComponent {
	@Input() yesno: Array<any>;
	@Input() products: Array<any>;
	@Input() locations: Array<any>;
	@Input() groupOffers: Array<any>;

	filters = {
		date_range: [],
		group_offer: null,
		product: null,
		nights_stay: null,
		location: null,
		stop_sale: null,
		transport_kind: null,
		www: null,
		sale: null,
		merlinx: null,
		limit: null,
		offer_name: null,
		promotion: null,
		archived: null,
	};

	readonly OfferTermTransport = OfferTransportKind;

	protected filtersDefinition = {
		group_offer: {
			type: 'number',
			isArray: true,
		},
		product: {
			type: 'number',
			isArray: true,
		},
		location: {
			type: 'number',
			isArray: true,
		},
	};

	private readonly date = new DateService();

	filtersDefault() {
		this.filtersClear();
	}

	get nightsStay(): number {
		return this.filters.nights_stay !== null ? this.filters.nights_stay - 1 : null;
	}
	set nightsStay(value: number) {
		this.filters.nights_stay = value !== null ? value + 1 : null;
	}

	filtersClear() {
		for (const key in this.filters) {
			if (Array.isArray(this.filters[key])) {
				this.filters[key] = [];
				continue;
			}
			this.filters[key] = null;
		}
		this.filters.date_range = [this.date.daysAdd(), this.date.daysAdd(+14)];
	}
}
